export const RoutePutStores_storeId_Status = "/stores/:storeId/status";

export interface PayloadPutStores_storeId_Status {
  status: "ACTIVE" | "ARCHIVED";
}
